"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsResponse = exports.ContactModel = exports.ContactFormService = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const json2typescript_1 = require("json2typescript");
const contactModalFields = [
    'id',
    'company_name',
    'type',
    'segments',
    'country_name',
    'country',
    'email',
];
const jsonConvert = new json2typescript_1.JsonConvert();
jsonConvert.valueCheckingMode = json2typescript_1.ValueCheckingMode.ALLOW_NULL;
const cache = {};
class ContactFormService {
    constructor(contactsApiUrl, locationApiKey) {
        this.connectionTimeout = 30000;
        this.contactsApiUrl = contactsApiUrl;
        this.locationApiKey = locationApiKey;
    }
    getContactById(contactId) {
        if (cache[contactId]) {
            return Promise.resolve(cache[contactId]);
        }
        const params = this.getRequestParams(contactId);
        const headers = { 'x-api-key': this.locationApiKey };
        return (0, app_1.api)(this.contactsApiUrl, params, headers, null, this.connectionTimeout).then(({ data }) => {
            const convertedContactDetailsData = jsonConvert.deserializeObject(data, ContactsResponse);
            const contacts = convertedContactDetailsData && convertedContactDetailsData.responseValue;
            cache[contactId] = contacts;
            return contacts;
        });
    }
    getRequestParams(contactId) {
        const idFilter = `id eq '${contactId}'`;
        return {
            $top: 1,
            $select: contactModalFields.join(', '),
            $filter: idFilter,
        };
    }
}
exports.ContactFormService = ContactFormService;
let ContactModel = class ContactModel {
    constructor() {
        this.id = undefined;
        this.companyName = undefined;
        this.type = undefined;
        this.segments = undefined;
        this.country = undefined;
        this.countryCode = undefined;
        this.email = undefined;
    }
};
exports.ContactModel = ContactModel;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('id', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "id", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('company_name', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('type', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "type", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('segments', [String]),
    tslib_1.__metadata("design:type", Array)
], ContactModel.prototype, "segments", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('country_name', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "country", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('country', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "countryCode", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('email', String),
    tslib_1.__metadata("design:type", String)
], ContactModel.prototype, "email", void 0);
exports.ContactModel = ContactModel = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('ContactModel')
], ContactModel);
let ContactsResponse = class ContactsResponse {
    constructor() {
        this.responseValue = undefined;
    }
};
exports.ContactsResponse = ContactsResponse;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('value', [ContactModel]),
    tslib_1.__metadata("design:type", Array)
], ContactsResponse.prototype, "responseValue", void 0);
exports.ContactsResponse = ContactsResponse = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('ContactsResponse')
], ContactsResponse);
